var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInstagramIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_28",
    "data-name": "Rectangle 28",
    width: 22,
    height: 22,
    transform: "translate(-0.132)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "instagram-icon",
    transform: "translate(0.132)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "instagram_6_",
    "data-name": "instagram (6)",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_285",
    "data-name": "Path 285",
    d: "M11,5.351A5.645,5.645,0,1,0,16.648,11,5.644,5.644,0,0,0,11,5.351Zm0,9.309A3.664,3.664,0,1,1,14.667,11,3.663,3.663,0,0,1,11,14.66Z",
    transform: "translate(0 -0.001)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_286",
    "data-name": "Path 286",
    d: "M15.535.07C13.511-.025,8.5-.02,6.472.07A6.574,6.574,0,0,0,1.856,1.849C-.259,3.965.011,6.815.011,11c0,4.279-.238,7.064,1.845,9.147C3.98,22.266,6.872,21.989,11,21.989c4.239,0,5.7,0,7.2-.577,2.038-.791,3.576-2.612,3.726-5.884.1-2.025.09-7.037,0-9.063C21.748,2.6,19.676.26,15.535.07Zm3.2,18.674c-1.387,1.387-3.311,1.263-7.762,1.263-4.583,0-6.421.068-7.762-1.277C1.67,17.193,1.95,14.724,1.95,10.981c0-5.064-.52-8.712,4.563-8.972,1.168-.041,1.512-.055,4.451-.055l.041.027c4.885,0,8.717-.511,8.947,4.57.052,1.16.064,1.508.064,4.443C20.016,15.525,20.1,17.374,18.739,18.744Z",
    transform: "translate(0 -0.001)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_6",
    "data-name": "Ellipse 6",
    cx: 1.319,
    cy: 1.319,
    r: 1.319,
    transform: "translate(15.553 3.809)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramIcon);
export default __webpack_public_path__ + "static/media/instagram-icon.84a5eb5e2c4babb3cd61cad2e8e25a0e.svg";
export { ForwardRef as ReactComponent };